module.exports = __webpack_public_path__ + "img/ScrewHeads.daab4fac.png";